import React, { Component } from 'react';
import { connect } from 'react-redux';
import BootstrapTable from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import ErrorBoundary from '../../../../Common/ErrorBoundary';
import '../../../../App.css';
import PropTypes from 'prop-types';
import Spinner from '..//../../../Common/Spinner';
import * as ReportActions from '../../../../Redux/Actions/Reports.Actions';
import paginationFactory, {
	PaginationProvider,
	PaginationListStandalone,
	PaginationTotalStandalone,
	SizePerPageDropdownStandalone
} from 'react-bootstrap-table2-paginator';
import { withClsCompTracking } from '../../../../Telemetry/telemetry.service';
import YearSelector from 'Common/Components/year-selector/YearSelector.container';
import qualYear from '../../../../mock-api/years/yearsResponse';
import Refiner from 'Common/Components/Refiner/Refiner.container';

const refinerFields = [
	{ name: 'appointmentTypeCode', label: "Type", type: 'list', allowEmpty: true },
	{ name: 'markingTeamTitle', label: 'Team Name contains', type: 'text' },
	{ name: 'markingTeamCode', label: 'Code', type: 'text', allowEmpty: true },
	{ name: 'markingMethod', label: 'Marking Method', type: 'text' },
	{ name: 'meetingDate', label: "Meeting Date", type: 'date', allowEmpty: true },
	{ name: 'venueName', label: 'Venue Name', type: 'list', allowEmpty: true },
	{ name: 'meetingTime', label: "Meeting Start Time", type: 'list', allowEmpty: true },
	{ name: 'meetingDuration', label: 'Meeting Duration', type: 'list', allowEmpty: true }
];


class MarkerMeetingsDatatable extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedYear: this.props.contract_globals.qualification_year.selected,
			searchYear: this.props.contract_globals.qualification_year.selected.toString(),
			contractTypes: this.props.contractTypes,
			keyField: 'rowId',
			columns: this.props.columns,
			pageNo: 1,
			pageSize: 1000,
			total: 0,
			apiCallCompleted: false,
			markerMeetings: [],
			visibleMarkerMeetings: [],
			markerMeetingsExportData: [],
			allMeetingYears: [],
			updateYear: PropTypes.func.isRequired,
			refinerOpen: true
		};
		this.componentRef = React.createRef();
		this.getData = this.props.handleGetMeetings;
		this.updateYear = this.updateYear.bind(this);
		this.getAllMeetingYears = this.props.handleGetAllMeetingYears;
	}

	componentDidMount = async () => {
		let flagMarkerMeeting = false;
		let flagExportData = false;
		const { pageNo, pageSize, contractTypes, selectedYear } = this.state;
		let query = {
			sortOrder: 'asc',
			sortField: 'markingTeamTitle',
			page: pageNo,
			sizePerPage: pageSize,
			searchText: '',
			flagMarkerMeeting,
			flagExportData
		};
		await this.getData(contractTypes, selectedYear, query);

        await this.getAllMeetingYears({ "0": "MAR", "1": "CMK" });
		
		this.setState({
			...this.state,
			apiCallCompleted: this.props.reports.apiCallCompleted,
			total: this.props.reports.markerMeetings[0].total,
			markerMeetings: this.props.reports.markerMeetings[0].data,
			visibleMarkerMeetings: this.props.reports.markerMeetings[0].data,
			allMeetingYears: this.props.reports.allMeetingYears
		});
		
	};

	handleTableChange = async (type, state) => {
		let flagMarkerMeeting = true;
		let flagExportData = false;
		let { sortOrder, sortField, page, sizePerPage, searchText } = state;
		let { selectedYear, contractTypes } = this.state;
		sortOrder = sortOrder ? sortOrder : 'asc';
		sortField = sortField ? sortField : 'markingTeamTitle';
		page = type === 'search' ? 1 : page;
		const query = {
			sortOrder,
			sortField,
			page,
			sizePerPage,
			searchText,
			flagMarkerMeeting,
			flagExportData
		};
		await this.getData(contractTypes, selectedYear, query);
		this.setState({
			...this.state,
			pageNo: page,
			pageSize: sizePerPage,
			apiCallCompleted: this.props.reports.apiCallCompleted,
			total: this.props.reports.markerMeetings[0].total,
			markerMeetings: this.props.reports.markerMeetings[0].data
		});
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
	};

	getExportData = async props => {
		let flagMarkerMeeting = true;
		let flagExportData = true;
		let searchText = '';
		let { selectedYear, contractTypes } = this.state;
		let page = 0,
			sizePerPage = 0;
		const query = {
			sortOrder: 'asc',
			sortField: 'markingTeamTitle',
			page,
			sizePerPage,
			searchText,
			flagMarkerMeeting,
			flagExportData
		};
		await this.getData(contractTypes, selectedYear, query);
		this.setState({
			...this.state,
			markerMeetingsExportData: this.props.reports.markerMeetings[0].data
		});

		props.onExport(this.state.markerMeetingsExportData);
	};

	updateYear = async year => {
		let flagMarkerMeeting = false;
		let flagExportData = false;
		this.setState({ isLoaded: false });
		const { contractTypes, handleGetMeetings } = this.props;
		const { selectedOption } = this.state;
		this.state.searchYear = year;
		const sizePerPage = this.state.pageSize;
		let page = 1;
		let searchText = '';
		if (selectedOption === 'active') {
			activeStatus = true;
		}
		let query = {
			sortOrder: 'asc',
			sortField: 'markingTeamTitle',
			page,
			sizePerPage,
			searchText,
			flagMarkerMeeting,
			flagExportData
		};
		await handleGetMeetings(contractTypes, year, query);
		this.setState({
			...this.state,
			markerMeetings: this.props.reports.markerMeetings[0].data
		});
		this.componentRef.scrollIntoView({ behavior: 'smooth' });
	};

	render() {
 
	   let { contractTypes, keyField, columns, apiCallCompleted, allMeetingYears, markerMeetings, visibleMarkerMeetings, pageNo, total, pageSize, searchYear, refinerOpen } = this.state;
		const { SearchBar } = Search;
		const handleUpdateYear = this.updateYear;
		const { onRefinementChange, onRefinerToggle } = this;


		//_Customized Export.
		const ExportCSVButton = props => {
			const handleClick = () => {
				this.getExportData(props);
			};
			return (
				<div>
					<button className="react-bs-table-csv-btn btn btn-default btn-primary" style={{ height: '45px', width: '200px' }} onClick={handleClick}>
						Export CSV
					</button>
				</div>
			);
		};

		let chkYear = markerMeetings.find(x => parseInt(x.qualificationYear) === parseInt(searchYear)) || 'Unmatched';
		if (chkYear === 'Unmatched') {
			markerMeetings = [];
			total = 0;
		}

		return (
			<ErrorBoundary>
				<div ref={el => (this.componentRef = el)}>
					<PaginationProvider
						pagination={paginationFactory({
							custom: true,
							totalSize: total,
							page: pageNo,
							sizePerPage: pageSize,
							showTotal: true,
							withFirstAndLast: true,
							alwaysShowAllBtns: true
						})}
						keyField={keyField}
						columns={columns}
						data={visibleMarkerMeetings}
					>
						{({ paginationProps, paginationTableProps }) => (
							<ToolkitProvider
								keyField={keyField}
								columns={columns}
								data={visibleMarkerMeetings}
								search={{ placeholder: 'Search...' }}
								exportCSV={{
									fileName: `contract_Management_${contractTypes.join('_')}.csv`,
									separator: ','
								}}
							>
								{toolkitProps => {
									return (
										<div className="container-fluid">
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'space-between',
													flexWrap: 'wrap'
												}}
											>
												<YearSelector  year={searchYear} grouping={this.state.grouping} updateYear={handleUpdateYear} listOfYears={allMeetingYears} />
											</div>
											<Refiner
												disabled={false}
												fields={refinerFields}
												open={refinerOpen}
												data={markerMeetings}
												onRefinementChange={onRefinementChange}
												onPanelToggleClick={onRefinerToggle}
											/>
											<br />


											<BootstrapTable
												classes={'table table-primary table-striped table-sm table-responsive-md'}
												{...toolkitProps.baseProps}
												{...paginationTableProps}
												remote={{
													pagination: true,
													search: true
												}}
												onTableChange={this.handleTableChange}
												filter={filterFactory()}
												bootstrap4
												striped
												condensed
												hover
												size="sm"
											/>
											{!apiCallCompleted && <Spinner />}
											<div
												style={{
													display: 'flex',
													flexDirection: 'row',
													justifyContent: 'space-between',
													flexWrap: 'wrap'
												}}
											>
												<ExportCSVButton {...toolkitProps.csvProps} />
											</div>
										</div>
									);
								}}
							</ToolkitProvider>
						)}
					</PaginationProvider>
				</div>
			</ErrorBoundary>
		);
	}

	onRefinerToggle = async () => {
		const { refinerOpen } = this.state;
		this.setState({ refinerOpen: !refinerOpen });
	};

	onRefinementChange = async (refined) => {
		this.setState({ visibleMarkerMeetings: refined });
	};

}

const mapStateToProps = state => {
	return {
		...state
	};
};

const mapDispatchToProps = dispatch => {
	return {
		handleGetMeetings: async (contractTypes, year, query) => await dispatch(ReportActions.getMarkerMeetings(contractTypes, year, query)),
		handleGetAllMeetingYears: async (query) => await dispatch(ReportActions.getAllMeetingYears(query))
	};
};

export default withClsCompTracking('Marker Meetings Table')(connect(mapStateToProps, mapDispatchToProps)(MarkerMeetingsDatatable));
// force merge